<!-- eslint-disable vue/no-v-html -->
<template>
  <Base :base-id="'popup-addon-detail'">
    <template #header>
      <button class="btn addon-tab-btn" :class="{ active: showImage }" @click="changeContent(1)">
        商品照片
      </button>
      <button class="btn addon-tab-btn" :class="{ active: !showImage }" @click="changeContent(2)">
        商品描述
      </button>
    </template>
    <template #body>
      <div v-if="showImage">
        <div class="color-wrap">
          <a
            v-for="(colorPic, index) in modalData.Colors"
            :key="'colorPic' + index"
            class="color-opts"
            :class="{ active: selectedImgIndex === index }"
            @click.prevent="changePicIdx(index)"
          >
            <img class="img-fluid" :src="colorPic.PintSizePictureUrl" />
          </a>
        </div>
        <div v-for="(colorPic, index) in modalData.Colors" :key="colorPic.ID">
          <div v-show="selectedImgIndex === index">
            <div v-for="img in colorPic.Images" :key="img.Url">
              <img class="img-fluid mb-2" :src="img.Url" />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-html="modalData.Description" />
        <br /><br />
        <div v-html="modalData.MaterialDescription" />
        <br /><br />
        <div class="item-report" v-html="modalData.SizeReport" />
        <br /><br />
        <div v-html="modalData.CareLabelDesc" />
      </div>
    </template>
  </Base>
</template>

<script setup>
import $ from 'jquery';
import { ref, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

import Base from '@global/components/common/modal/Base.vue';

import useModalStore from '@global/stores/useModalStore';

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);

const selectedImgIndex = ref(0);
const showImage = ref(true);

watch(showImage, (nV, oV) => {
  if (nV) return;
  nextTick(() => {
    // 不是每個品牌都有 確定PAZZO有
    const btnCollapse = $('#popup-addon-detail .size-guide__section > h2');

    btnCollapse.on('click', function (e) {
      const $selfContent = $(this).parent().find('.size-guide__content');
      if ($(this).hasClass('show')) return;

      btnCollapse.removeClass('show');
      $(this).addClass('show');
      $('.size-guide__content').slideUp('400');
      $selfContent.slideDown('400');
    });
  });
});

function changePicIdx(idx) {
  selectedImgIndex.value = idx;
}

function changeContent(tab) {
  if (tab === 1) {
    showImage.value = true;
  } else {
    showImage.value = false;
  }
}
</script>
